var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbbviePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 8.71429H8.71429V13H7.28571V8.71429H3V7.28571H7.28571V3H8.71429V7.28571H13V8.71429Z",
    fill: "#071C47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbviePlus);
export default __webpack_public_path__ + "static/media/abbviePlus.517ac3c2636b0eff818775e6749a5fd4.svg";
export { ForwardRef as ReactComponent };